import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import Mensaje from "sweetalert";
import { useStoreLogin } from "../Login/useStoreLogin";
import { normalizarSesionEmpresa } from "../../servicios/empresa";
import { PASSWORD_MIN_LENGTH_ERROR, passwordCumpleLongitudMinima } from "../../servicios/passwordPolicy";

export const useStoreRegistro = create((set, get) => {
    return {
        Mail:"",
        Password:"",
        ConfirmPassword:"",
        Descripcion:"",
        Nombre:"",
        Apellido:"",
        Cuit:"",
        Rubro:"",
        limpiar: () => {
            set({ Mail:"", Password:"", ConfirmPassword:"", Descripcion:"", Nombre:"", Apellido:"", Cuit:"", Rubro:"" });
        },
        Procesando: false,
        insertOperador: async () => {
            if (get().Procesando) { return; }
            if (!passwordCumpleLongitudMinima(get().Password)) {
                Mensaje("Contraseña inválida", PASSWORD_MIN_LENGTH_ERROR, "error");
                return;
            }
            const sParametros = {
                Mail: get().Mail,
                PassWord: get().Password,
                Descripcion: get().Descripcion,
                Nombre: get().Nombre,
                Apellido: get().Apellido,
                Cuit: String(get().Cuit || "").trim(),
                Rubro: get().Rubro

            };
            set({ Procesando: true });
            const data = await _Componentes_WebApiCalls_Post("PISeunLogin/Insert", sParametros);
            if (data.error) {
                Mensaje("Error al intentar registrarse", data.error, "error");
            } else {
                const sesion = normalizarSesionEmpresa(data.data);
                useStoreLogin.setState({
                    Mail: get().Mail,
                    Password: "",
                    EmpresaId: sesion.EmpresaId,
                    Id: 0,
                    LoginOk: false
                });
                localStorage.removeItem("Password");
                set({ RegistroOk: true });
                Mensaje("Registro exitoso", "La cuenta fue creada. Inicie sesión para continuar.", "success");
            }
            set({ Procesando: false });
        }
    }
});
